export default {
  work_experience_from: true,
  work_experience_to: true,

  education_from: true,
  education_to: true,

  awards_and_honors_issue_date: true,

  volunteer_work_from: true,
  volunteer_work_to: true,

  certifications_from: true,
  certifications_to: true,

  projects_from: true,
  projects_to: true,

  leadership_from: true,
  leadership_to: true,

  associations_from: true,
  associations_to: true,

  courses_completion_date: true,

  conferences_date: true,

  patents_patent_date: true,

  test_scores_date: true,

  letter_date: true,
};
